import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { SwitcherService } from "../../services/switcher.service";
import * as switcher from "./switcher";

@Component({
  selector: "app-switcher",
  templateUrl: "./switcher.component.html",
  styleUrls: ["./switcher.component.scss"],
  standalone: false
})
export class SwitcherComponent implements OnInit {
  // theme style
  layoutSub: Subscription;
  body = document.querySelector("body");
  @ViewChild("switcher", { static: true }) switcher!: ElementRef;

  constructor(
    public renderer: Renderer2,
    public switcherServic: SwitcherService,
    private modalService: NgbModal
  ) {
    this.layoutSub = switcherServic.changeEmitted.subscribe((value) => {
      if (value) {
        this.renderer.addClass(
          this.switcher.nativeElement.firstElementChild,
          "active"
        );
        this.renderer.setStyle(
          this.switcher.nativeElement.firstElementChild,
          "right",
          "0px"
        );
        value = true;
      } else {
        this.renderer.removeClass(
          this.switcher.nativeElement.firstElementChild,
          "active"
        );
        this.renderer.setStyle(
          this.switcher.nativeElement.firstElementChild,
          "right",
          "-270px"
        );
        value = false;
      }
      document.querySelector(".slide-leftRTL")?.classList.add("d-none");
      document.querySelector(".slide-rightRTL")?.classList.add("d-none");
    });
  }
  ngOnInit(): void {
    switcher.localStorageBackUp();
    switcher.customClickFn();
    switcher.updateChanges();
    // document.querySelector('#myonoffswitch1').checked = true
    if (
      document.body.classList.contains("transparent-mode") ||
      document.body.classList.contains("dark-mode")
    ) {
      // console.log('true');
      let light = document.getElementById("myonoffswitch1") as HTMLInputElement;
      light.checked = false;
    } else {
      // console.log('false');
      let light = document.getElementById("myonoffswitch1") as HTMLInputElement;
      light.checked = true;
    }
  }
  reset() {
    let btnlight = document.getElementById(
      "myonoffswitch1"
    ) as HTMLInputElement;
    btnlight.checked = true;
    let lightmenu = document.getElementById(
      "myonoffswitch3"
    ) as HTMLInputElement;
    lightmenu.checked = true;
    let vertical = document.getElementById(
      "myonoffswitch34"
    ) as HTMLInputElement;
    vertical.checked = true;
    let ltr = document.getElementById("myonoffswitch54") as HTMLInputElement;
    ltr.checked = true;
    let lightheader = document.getElementById(
      "myonoffswitch6"
    ) as HTMLInputElement;
    lightheader.checked = true;
    let fullwidth = document.getElementById(
      "myonoffswitch9"
    ) as HTMLInputElement;
    fullwidth.checked = true;
    let fixed = document.getElementById("myonoffswitch11") as HTMLInputElement;
    fixed.checked = true;

    localStorage.clear();
    let html: any = document.querySelector("html");
    let body = document.querySelector("body");
    html.style = "";
    body?.classList.remove("rtl");
    body?.classList.remove("dark-mode");
    body?.classList.remove("light-header");
    body?.classList.remove("dark-header");
    body?.classList.remove("color-header");
    body?.classList.remove("gradient-header");
    body?.classList.remove("light-menu");
    body?.classList.remove("color-menu");
    body?.classList.remove("dark-menu");
    body?.classList.remove("gradient-menu");
    body?.classList.remove("layout-boxed");
    body?.classList.remove("scrollable-layout");
    body?.classList.remove("transparent-mode");
    switcher.updateChanges();
    switcher.checkOptions();
    html.setAttribute("dir", "ltr");
    let styleId = document.querySelector("#style");
    styleId?.setAttribute(
      "href",
      "./assets/plugins/bootstrap/css/bootstrap.css"
    );
    localStorage.removeItem("Yohahorizontal");
    localStorage.removeItem("YohahorizontalHover");
    let mainContent: any = document.querySelector(".main-content");
    let mainContainer1: any = document.querySelectorAll(".main-container");
    let appSidebar: any = document.querySelector(".app-sidebar");
    let header: any = document.querySelector(".header");
    let mainSidemenu: any = document.querySelector(".main-sidemenu");
    mainContent?.classList.add("app-content");
    mainContainer1.forEach((e: any) => {
      e.classList.add("container-fluid");
    });
    header?.classList.add("app-header");
    body?.classList.add("sidebar-mini");
    //remove
    body?.classList.remove("horizontal");
    body?.classList.remove("horizontal-hover");
    appSidebar?.classList.remove("horizontal-main");
    mainSidemenu?.classList.remove("container");
    mainContent?.classList.remove("hor-content");
    header?.classList.remove("hor-header");
    mainContainer1.forEach((e: any) => {
      e.classList.remove("container");
    });
    document.querySelector(".slide-left")?.classList.add("d-none");
    document.querySelector(".slide-right")?.classList.add("d-none");
    document.querySelector(".slide-leftRTL")?.classList.add("d-none");
    document.querySelector(".slide-rightRTL")?.classList.add("d-none");
  }

  public color1: string = "#3b46e6";
  public color2: string = "#dc3545";
  public color3: string = "#6c5ffc";
  public color4: string = "#262d47";
  public color13: string = "#6c5ffc";

  public dynamicBgPrimary(data: any): void {
    this.color3 = data;

    const dynamicPrimaryBg = document.querySelectorAll(".color-primary-Bg");

    switcher.dynamicBgPrimaryColor(dynamicPrimaryBg, this.color3);
    localStorage.setItem("Yohatransparent-primary-color", this.color3);
    localStorage.setItem("Yohatransparent-primary-hover", this.color3);
    localStorage.setItem("Yohatransparent-primary-border", this.color3);
    let transparent = document.getElementById(
      "myonoffswitch1"
    ) as HTMLInputElement;
    transparent.checked = true;

    // Adding
    this.body?.classList.add("dark-mode");
    localStorage.setItem("YohadarkTheme", "true");

    // Removing
    this.body?.classList.remove("dark-mode");
    this.body?.classList.remove("light-mode");
    localStorage.removeItem("YohaDarkTheme");
    localStorage.removeItem("YohaLightTheme");
    this.body?.classList.remove("light-header");
    this.body?.classList.remove("dark-header");
    this.body?.classList.remove("color-header");
    this.body?.classList.remove("gradient-header");
    this.body?.classList.remove("light-menu");
    this.body?.classList.remove("color-menu");
    this.body?.classList.remove("dark-menu");
    this.body?.classList.remove("gradient-menu");
    document
      .querySelector(".app-header")
      ?.classList.add(
        "hor-header",
        "fixed-header",
        "visible-title",
        "stickyClass"
      );

    localStorage.removeItem("Yohalight-primary-color");
    localStorage.removeItem("Yohalight-primary-hover");
    localStorage.removeItem("Yohalight-primary-border");
    localStorage.removeItem("Yohadark-primary-color");
    localStorage.removeItem("Yohadark-primary-hover");
    localStorage.removeItem("Yohadark-primary-border");
    localStorage.removeItem("Yohadark-body");
    // localStorage.removeItem('YohaBgImage');
    // localStorage.removeItem('Yohatransparent-bg-color');
    switcher.removeForTransparent();
    switcher.updateChanges();
  }

  public dynamicBgDarkPrimary(data: any): void {
    document.body.classList.add("dark-mode");

    this.color4 = data;

    const dynamicPrimaryBgDark = document.querySelectorAll(".color-bg-Dark");

    switcher.dynamicBgDarkPrimaryColor(dynamicPrimaryBgDark, this.color4);
    localStorage.setItem("Yohatransparent-bg-color", this.color4);
    let BgDark = document.getElementById("myonoffswitch2") as HTMLInputElement;
    BgDark.checked = false;

    // Adding
    // this.body?.classList.add('dark-mode');
    //  localStorage.setItem('YohaDarkTheme', 'false');

    // Removing
    localStorage.removeItem("YohaLightTheme");
    this.body?.classList.remove("light-mode");
    this.body?.classList.remove("light-header");
    this.body?.classList.remove("dark-header");
    this.body?.classList.remove("color-header");
    this.body?.classList.remove("gradient-header");
    this.body?.classList.remove("light-menu");
    this.body?.classList.remove("color-menu");
    this.body?.classList.remove("dark-menu");
    this.body?.classList.remove("gradient-menu");
    document
      .querySelector(".app-header")
      ?.classList.add(
        "hor-header",
        "fixed-header",
        "visible-title",
        "stickyClass"
      );

    localStorage.removeItem("Yohalight-primary-color");
    localStorage.removeItem("Yohalight-primary-hover");
    localStorage.removeItem("Yohalight-primary-border");
    localStorage.removeItem("Yohadark-primary-color");
    // localStorage.removeItem('Yohatransparent-bgImg-primary-color');
    localStorage.removeItem("YohaBgImage");
    switcher.removeForTransparent();
    switcher.updateChanges();
  }

  closeResult = "";

  open(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
}
